import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services';
import { catchError, map, take } from 'rxjs/operators';
import { TransportManagementExportService } from './transport-management-export.service';
import { TransportManagementExportToFileStart } from './transport-management-export.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { NavigateUserService } from '../../../../services/navigate-user.service';

@State({
  name: 'transportManagementExport',
})
@Injectable()
export class TransportManagementExportState {
  constructor(
    private transportManagementExportService: TransportManagementExportService,
    private notificationService: NotificationService,
    private navigateUserService: NavigateUserService,
  ) {}

  @Action(TransportManagementExportToFileStart)
  startExportToFile(
    ctx: StateContext<unknown>,
    { payload: { dialogRef, navigationNeeded, ...body } }: TransportManagementExportToFileStart,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportManagementExportService.startExportToFile(body).pipe(
      take(1),
      map(() => {
        this.notificationService.success('api.export.success.exportStart');
        dialogRef.close();
        if (navigationNeeded) {
          this.navigateUserService.navigateUserToAbsolutePath('/dashboard/exports');
        }
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }
}
